import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 80px 0 40px 0 ;
  border-bottom: 2px solid #484848;

`;
